'use client';

import { handle_GTM_33 } from '@gtm/33';
import { handle_GTM_34 } from '@gtm/34';
import { handle_GTM_52 } from '@gtm/52';
import { handle_GTM_54 } from '@gtm/54';
import { ItfGTM54 } from '@gtm/54/type';
import { handle_GTM_64 } from '@gtm/64';
import { handle_GTM_69 } from '@gtm/69';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { useIntersectionObservers } from 'eco-design-micro/hooks/useIntersectionObservers';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import Arrow from '../../product-series/content/icons';
import { defaultChild } from '../setting/config';
import { ItfComparesBtn, ItfComparesChild, ItfComparesColor, ItfComparesData, ItfComparesItem, ItfComparesLink, ItfComparesSpec } from '../setting/type';
import './index.scss';
import { Swiper as SwiperType } from 'swiper/types';

interface ItfAniArrItem {
    name: string;
    cls: string;
}
export default function Content({ id, data = {}, isEditStatus }: ContentServerProps) {
    const { theme, title, titleColor, children = [defaultChild] as ItfComparesChild[] } = data as ItfComparesData;
    const [activeChildIdx, setActiveChildIdx] = useState<number>(0);
    const [activeColors, setActiveColors] = useState<number[]>(new Array(children?.[activeChildIdx]?.items?.length || 0).fill(0));
    // console.log('data', data);
    const [swiper, setSwiper] = useState<SwiperType | null>(null);
    const swiperRef = useRef<any>(null);
    const prefixCls = 'product-compares';
    const [gap, setGap] = useState<number>(16);
    const [h, setH] = useState<number>(0);
    const [enter, setEnter] = useState({
        title: isEditStatus,
        tabs: isEditStatus,
        slide: isEditStatus,
    });

    const handleChangeTab = (i: number, e: React.MouseEvent<HTMLLIElement>, item: ItfComparesChild) => {
        setActiveChildIdx(i);
        setH(0);
        e.currentTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        handle_GTM_54({
            list_name: title,
            button_name: item?.tab,
            __btn_id1: `editor-${prefixCls}-${id}`,
            __btn_id2: item?.tab,
            __btn_type: 'text',
        } as ItfGTM54);
    };

    const handleChangeColor = (i: number, j: number) => {
        const temp = JSON.parse(JSON.stringify(activeColors));
        temp[i] = j;
        setActiveColors(temp);
        setH(0);
        const color: string = children?.[activeChildIdx]?.items?.[i]?.colors?.[j]?.color || '';
        handle_GTM_54({
            list_name: title,
            button_name: color,
            __btn_id1: `editor-${prefixCls}-${id}`,
            __btn_id2: color,
            __btn_type: 'common',
        });
    };

    // 上半部分的 css对齐
    const initInfoCss = () => {
        if (h > 0) return;
        const doms: NodeListOf<HTMLUListElement> = document.querySelectorAll(`.editor-${prefixCls}-${id} .${prefixCls}-swiper-slide-items`);
        if (doms?.length > 1) {
            const maxHeight = Array.from(doms).reduce((max, dom) => {
                return Math.max(max, dom.offsetHeight || 0);
            }, 0);

            console.log('最高列的高度:', maxHeight);
            setH(maxHeight);
        }
    };

    const initSpecItemCss = () => {
        const rows = children?.[activeChildIdx]?.items?.reduce((max, item) => Math.max(max, item?.specs?.length || 0), 0) || 0;
        const cols = children?.[activeChildIdx]?.items?.length || 0;
        if (cols > 0 && rows > 0) {
            for (let i = 0; i < rows; i++) {
                const domsRow: NodeListOf<HTMLLIElement> = document.querySelectorAll(`.editor-${prefixCls}-${id} .spec-${i}`);
                let mx = 0;
                for (let j = 0; j < cols; j++) {
                    if (domsRow?.[j]?.offsetHeight > mx) {
                        mx = domsRow?.[j]?.offsetHeight;
                    }
                }
                for (let k = 0; k < domsRow?.length; k++) {
                    domsRow[k].style.height = mx + 'px';
                }
            }
        }
    };

    // 下半部分spec的 css对齐
    const initSpecCss = () => {
        // 找spec最多的数量
        const specN = children?.[activeChildIdx]?.items?.reduce((max, item) => Math.max(max, item?.specs?.length || 0), 0) || 0;

        for (let i = 0; i < specN; i++) {
            const doms: NodeListOf<HTMLUListElement> = document.querySelectorAll(
                `.editor-${prefixCls}-${id} .${prefixCls}-swiper .${prefixCls}-swiper-slide .item-specs .item-spec:nth-child(${i + 1})`,
            );
            if (doms?.length > 0) {
                const maxH = Array.from(doms).reduce((max, dom) => Math.max(max, dom?.offsetHeight || 0), 0);
                if (maxH > 0) {
                    Array.from(doms).forEach((dom) => {
                        dom.style.height = `${maxH}px`;
                    });
                }
            }
        }
    };

    const arr: ItfAniArrItem[] = [
        { name: 'title', cls: `${prefixCls}-info-title` },
        { name: 'tabs', cls: `${prefixCls}-tabs-wrapper` },
        { name: 'slide', cls: `${prefixCls}-swiper-box` },
    ];

    useIntersectionObservers(
        {
            selectors: [
                `.editor-${prefixCls}-${id} .${prefixCls}-info-title`,
                `.editor-${prefixCls}-${id} .${prefixCls}-tabs-wrapper`,
                `.editor-${prefixCls}-${id} .${prefixCls}-swiper-box`,
            ],
            onEnter: (e: Element) => {
                const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
                if (aim) {
                    setEnter((prev) => ({ ...prev, [aim.name]: true }));
                }
            },
            // onLeave: (e: Element) => {
            //     const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
            //     if (aim) {
            //         setEnter((prev) => ({ ...prev, [aim.name]: false }));
            //     }
            // },
        },
        [],
        isEditStatus,
    );

    const handle_GTM_Event = (btn: ItfComparesBtn | ItfComparesLink, name: string) => {
        const { url, text } = btn;
        // 1. checkout => https://us.ecoflow.com/checkouts/cn/hWN6bOi6WvZ1r1ECVcafOoKO/en-us?_r=AQABFnGHZn-cZ1lZW7AM6Pa19wIXIWn4XUcLF8yGzrkL
        const regex1 = /^https:\/\/[a-z]{2}\.ecoflow\.com\/(?:cart|checkouts)\//i;
        const regex2 = /^https:\/\/[a-z]{2}\.ecoflow\.com\//i;
        const regex3 = /^(https:\/\/)?www\.ecoflow\.com\/[a-z]{2}\//i;
        if (regex1.test(url)) {
            // 1. checkout shopify结账页
            handle_GTM_34({
                button_name: `${text}_${name}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex2.test(url)) {
            // 2. shopify 其他页
            handle_GTM_33({
                product_name: name,
                position: `Series_ProductCompares_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex3.test(url)) {
            // 3. 官网网页
            handle_GTM_52({
                list_name: title,
                product_name: name,
                button_name: text,
                position: `Series_ProductCompares_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else {
            // 4. 其他
            handle_GTM_64({
                list_name: title,
                button_name: text,
                position: `Series_ProductCompares_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        }
    };

    const handleGTM = (btn: string) => {
        handle_GTM_69({
            button_name: btn,
            position: `Series_ProductCompares-${id}`,
            __btn_id1: `editor-${prefixCls}-${id}`,
            __btn_id2: btn,
            __btn_type: 'common',
        });
    };

    useLayoutEffect(() => {
        if (typeof window !== 'undefined') {
            initInfoCss();
            initSpecItemCss();
            setTimeout(() => {
                initSpecCss();
            }, 500);
        }
    }, [activeChildIdx, activeColors]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 ? 32 : 16);
        }
    }, []);

    useEffect(() => {
        setActiveColors(new Array(children?.[activeChildIdx]?.items?.length || 0).fill(0));
    }, [activeChildIdx, children?.[activeChildIdx]?.items]);

    useEffect(() => {
        if (swiperRef.current && swiper) {
            const prev = swiperRef.current.querySelector('.swiper-button-prev');
            const next = swiperRef.current.querySelector('.swiper-button-next');
            if (prev) {
                prev.classList.add('GtmModuleData-btn-common');
                prev.setAttribute('data-btn-id', '<');
                prev.addEventListener('click', () => handleGTM('<'));
            }
            if (next) {
                next.classList.add('GtmModuleData-btn-common');
                next.setAttribute('data-btn-id', '>');
                next.addEventListener('click', () => handleGTM('>'));
            }
            return () => {
                if (prev) {
                    prev.removeEventListener('click', () => handleGTM('<'));
                }
                if (next) {
                    next.removeEventListener('click', () => handleGTM('>'));
                }
            };
        }
    }, [swiperRef.current, swiper]);

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id} theme-${theme}`} id={id} data={data} floorName={prefixCls}>
            <div className={`${prefixCls}-info`}>
                {title && (
                    <div className={`${prefixCls}-info-title ${enter?.title ? 'enter' : ''}`} style={{ color: titleColor }} title={title}>
                        {title}
                    </div>
                )}
            </div>
            <div className={`${prefixCls}-tabs-wrapper ${enter?.tabs ? 'enter' : ''}`}>
                {children?.length > 0 && (
                    <ul className={`${prefixCls}-tabs`}>
                        {children.map((child: ItfComparesChild, i: number) => (
                            <li
                                key={i}
                                className={`${prefixCls}-tabs-tab GtmModuleData-btn-text ${i === activeChildIdx ? 'active' : ''}`}
                                onClick={(e: React.MouseEvent<HTMLLIElement>) => handleChangeTab(i, e, child)}
                            >
                                {child.tab}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className={`${prefixCls}-swiper-box`} ref={swiperRef}>
                <Swiper
                    key={`${activeChildIdx}`}
                    className={`${prefixCls}-swiper`}
                    initialSlide={0}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    modules={[Navigation]}
                    navigation={true}
                    onSwiper={(swiperIns: SwiperType) => setSwiper(swiperIns)}
                >
                    {children?.[activeChildIdx]?.items?.map((item: ItfComparesItem, i: number) => {
                        const IS_NORMAL: boolean = item?.type === 'normal';
                        const colors: string[] | undefined = item?.colors?.map((color: ItfComparesColor) => color?.color);
                        const hasColors = children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) =>
                            item?.colors?.map((color: ItfComparesColor) => color?.color && color?.img),
                        );
                        const hasLabel = IS_NORMAL
                            ? children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) => item?.label)
                            : children?.[activeChildIdx]?.items?.some((item: ItfComparesItem, k: number) =>
                                  item?.colors?.find((color: ItfComparesColor, m: number) => m === activeColors[k] && color?.label),
                              );
                        const hasName = children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) => item?.name);
                        const hasText = children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) => item?.text);
                        const hasBtn = IS_NORMAL
                            ? children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) =>
                                  item?.btns?.map((btn: ItfComparesBtn) => btn?.text && btn?.url),
                              )
                            : children?.[activeChildIdx]?.items?.some((item: ItfComparesItem, k: number) =>
                                  item?.colors?.[activeColors?.[k]].btns?.map((btn: ItfComparesBtn) => btn?.text && btn?.url),
                              );
                        const hasSpec = children?.[activeChildIdx]?.items?.some((item: ItfComparesItem) =>
                            item?.specs?.map((spec: ItfComparesSpec) => spec?.name && spec?.text),
                        );
                        return (
                            <SwiperSlide
                                className={`${prefixCls}-swiper-slide item-${i} ${enter?.slide ? 'enter' : ''}`}
                                style={{ transitionDelay: enter?.slide ? `${(i + 1) * 0.15}s` : '0s' }}
                                key={`${JSON.stringify(activeColors)}-${i}`}
                            >
                                {IS_NORMAL ? (
                                    <ul className={`${prefixCls}-swiper-slide-items`} style={h > 0 ? { height: `${h}px` } : {}}>
                                        <li className={`${prefixCls}-swiper-slide-items-item active`}>
                                            <div className="item-img">
                                                <EcoImg pc={item?.img} alt={item.name} aria-label={item.name} />
                                            </div>
                                            {hasColors && (
                                                <ul className="item-colors" style={{ pointerEvents: 'none' }}>
                                                    {colors?.map((_: string, m: number) => (
                                                        <li className={`item-color`} key={`${i}-${m}`}>
                                                            <span className="color-inner"></span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                            {hasLabel && <p className="item-label">{item?.label || ' '}</p>}
                                            {hasName && (
                                                <p className="item-name" title={item?.name}>
                                                    {item?.name || ' '}
                                                </p>
                                            )}
                                            {hasText && (
                                                <p className="item-text" title={item?.text}>
                                                    {item?.text || ' '}
                                                </p>
                                            )}
                                            {hasBtn && (
                                                <div className="item-btns">
                                                    {item?.btns?.map(
                                                        (btn: ItfComparesBtn, m: number) =>
                                                            btn?.url &&
                                                            btn?.text && (
                                                                <EcoLink
                                                                    className={`item-btn GtmModuleData-btn-href type-${btn?.type}`}
                                                                    key={`${i}-${m}`}
                                                                    href={btn?.url}
                                                                    onClick={() => handle_GTM_Event(btn, item?.name)}
                                                                >
                                                                    <span className="btn-text">{btn?.text}</span>
                                                                    {btn?.type === 'text' && <Arrow />}
                                                                </EcoLink>
                                                            ),
                                                    )}
                                                </div>
                                            )}
                                        </li>
                                    </ul>
                                ) : (
                                    <ul className={`${prefixCls}-swiper-slide-items`} style={h > 0 ? { height: `${h}px` } : {}}>
                                        {item?.colors?.map((color: ItfComparesColor, j: number) => (
                                            <li
                                                className={`${prefixCls}-swiper-slide-items-item j-${j} activeColors-${activeColors} ${
                                                    activeColors[i] === j ? 'active' : ''
                                                }`}
                                                key={`${i}-${j}`}
                                            >
                                                <div className="item-img">
                                                    <EcoImg pc={color?.img} alt={item.name} aria-label={item.name} />
                                                </div>
                                                {hasColors && (
                                                    <ul className="item-colors">
                                                        {colors?.map((cor: string, m: number) => (
                                                            <li
                                                                className={`item-color GtmModuleData-btn-common ${activeColors[m] === m ? 'active' : ''}`}
                                                                key={`${i}-${j}-${m}`}
                                                                style={activeColors[i] === m ? { borderColor: cor } : {}}
                                                                data-btn-id={cor}
                                                                onClick={() => handleChangeColor(i, m)}
                                                            >
                                                                <span className="color-inner" style={{ backgroundColor: cor }}></span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                {hasLabel && <p className="item-label">{color?.label || ' '}</p>}
                                                {hasName && (
                                                    <p className="item-name" title={item?.name}>
                                                        {item?.name || ' '}
                                                    </p>
                                                )}
                                                {hasText && (
                                                    <p className="item-text" title={item?.text}>
                                                        {item?.text || ' '}
                                                    </p>
                                                )}
                                                {hasBtn && (
                                                    <div className="item-btns">
                                                        {color?.btns?.map(
                                                            (btn: ItfComparesBtn, m: number) =>
                                                                btn?.url &&
                                                                btn?.text && (
                                                                    <EcoLink
                                                                        className={`item-btn GtmModuleData-btn-href type-${btn?.type}`}
                                                                        key={`${i}-${j}-${m}`}
                                                                        href={btn?.url}
                                                                        onClick={() => handle_GTM_Event(btn, item?.name)}
                                                                    >
                                                                        <span className="btn-text">{btn?.text}</span>
                                                                        {btn?.type === 'text' && <Arrow />}
                                                                    </EcoLink>
                                                                ),
                                                        )}
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {hasSpec && (
                                    <>
                                        <p className="item-line"></p>
                                        <ul className="item-specs">
                                            {item?.specs?.map((spec: ItfComparesSpec, j: number) => (
                                                <li className={`item-spec spec-${j}`} key={`${i}-${j}`}>
                                                    {spec?.text && (
                                                        <p className="spec-text" title={spec?.text}>
                                                            {spec?.text}
                                                        </p>
                                                    )}
                                                    {spec?.name && (
                                                        <p className="spec-name" title={spec?.name}>
                                                            {spec?.name}
                                                        </p>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <div className={`${prefixCls}-links`}>
                {children?.[activeChildIdx]?.links?.map(
                    (link: ItfComparesLink, i: number) =>
                        link?.text &&
                        link?.url && (
                            <EcoLink
                                href={link?.url}
                                className={`${prefixCls}-links-link GtmModuleData-btn-href`}
                                onClick={() => handle_GTM_Event(link, title)}
                                key={i}
                            >
                                <span>{link?.text}</span>
                                <Arrow />
                            </EcoLink>
                        ),
                )}
            </div>
        </GloLayout>
    );
}
